// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.
'use strict';

import Vue from "vue";
import pApi from '../api/patient';

import { apiURL } from "@/app.config";

var storage = window.localStorage;

function findContactIdx(book, contact) {
  const c = book.find((c) => c.Ref === contact.Ref)
  return book.indexOf(c);
}

export default {
  namespaced: true,
  state: {
    list: [],
    selectedPatient: undefined,
    overallAdherence: 0.0,
    reporturl: '',
    anomalyList: [],
    addressbook: {},
  },
  getters: {
    filteredByReference: (state) => (str) => {
      return state.list.filter(p => str == ''
                               || p.Name.toLowerCase().includes(str.toLowerCase()));
    },
    findPatient: (state) => (id) => {
      let p = state.list.find(function(patient) {
        return patient.ID === id;
      });
      return p;
    },
  },
  mutations: {
    setPatients(state, patients) {
      const list = patients || []
      //TODO: need to fix backend to add watched attri
      state.list = list.map((p) => { return Object.assign({Watch: false}, p)});
    },
    addNewPatient(state, patient) {
      state.list.push(patient);
    },
    removePatient(state, patient) {
      let idx = state.list.indexOf(patient);
      if (idx > -1) {
        state.list.splice(idx, 1);
      }
    },
    updatePatient(state, patient) {
      let p = state.list.find(function(item) {
        return item.ID === patient.ID;
      });

      let idx = state.list.indexOf(p);
      if (idx > -1) {
        Vue.set(state.list, idx, patient);
      } else {
        Vue.set(state.list, state.list.length, patient)
      }
      state.selectedPatient = patient;
    },
    setSelectedPatient(state, patient) {
      state.selectedPatient = patient;
      storage.setItem('pid', patient.ID);
    },
    setOverallAdherence(state, score) {
      state.overallAdherence = score;
    },
    setReportUrl(state, hash) {
      state.reporturl = `${apiURL}report/${hash}/pharmacist`;
    },
    setAnomalyList(state, list) {
      state.anomalyList = list
    },
    setAddressbook(state, {patientid, contacts}) {
      Vue.set(state.addressbook, patientid, contacts)
    },
    addContact(state, {patientid, contact}) {
      let book = state.addressbook[patientid] || []
      const idx = findContactIdx(book, contact)
      if (idx > -1) {
        book[idx] = contact
      } else {
        book.push(contact)
      }
      Vue.set(state.addressbook, patientid, book)
    },
    removeContact(state, {patientid, contact}) {
      let book = state.addressbook[patientid]
      if (Array.isArray(book)) {
        const idx = findContactIdx(book, contact)
        if (idx > -1) {
          book.splice(idx, 1)
          Vue.set(state.addressbook, patientid, book)
        }
      }
    }
  },
  actions: {
    async setSelectedPatient({dispatch, commit, state, getters}, id) {
      if (state.list.length == 0) {
        await dispatch('getAllPatients');
      }
      const pid = id || storage.getItem('pid')
      console.log('pid', pid)
      let p = getters.findPatient(pid)
      console.log(p);
      if (p === undefined) {
        throw new Error('Unable to find patient');
      }
      commit('setSelectedPatient', p);
      await dispatch('getOverallAdherence', p);
      await dispatch('getReportHash', p);
    },
    async getAllPatients({commit}) {
      let data = await pApi.getPatients();
      commit('setPatients', data.patients);
    },
    async getOverallAdherence({commit}, patient) {
      let data = await pApi.getPatientOverallAdherence(patient);
      commit("setOverallAdherence", data)
    },
    async getReportHash({commit}, patient) {
      let hash = await pApi.getReportHash(patient)
      commit("setReportUrl", hash)
    },
    async newPatient({commit}, patient) {
      let p = await pApi.storePatient(patient);
      if (p != null)  {
        commit('addNewPatient', p);
        return p;
      }
      return null;
    },
    async storePatient({commit}, patient) {
      let p = await pApi.storePatient(patient);
      if (p != null) {
        commit('updatePatient', p);
      }
    },
    async removePatient({commit}, patient) {
      let ok = await pApi.removePatient(patient);
      if (ok) {
        commit('removePatient', patient);
      }
      return ok;
    },
    async updateRecipients({dispatch, state}, recipients) {
      let p = Object.assign({}, state.selectedPatient);
      p.Recipients = recipients;
      dispatch('storePatient', p);
    },
    async updateReminders({dispatch, state}, reminders) {
      let p = Object.assign({}, state.selectedPatient);
      p.Reminders = reminders;
      dispatch('storePatient', p);
    },
    async updateAnomalyList({commit}) {
      let l = await pApi.fetchAnomalyList()
      if (l != null) {
        commit('setAnomalyList', l)
      }
    },
    async getAddressbook({commit}, patientid)  {
      let book = await pApi.getAddressbook(patientid)
      if (book != null) {
        commit('setAddressbook', patientid, book)
      }
    },
    async addContact({commit, state}, {patientid, contact}) {
      // need to update the state then update the data
      commit('addContact', {patientid, contact})
      let book = state.addressbook[patientid]
      let adbk = await pApi.updateAddressbook(patientid, book)
      if (adbk != null) {
        return true
      }
      return false
    },
    async removeContact({commit, state}, {patientid, contact}) {
      commit('removeContact', {patientid, contact})
      let book = state.addressbook[patientid]
      let res = await pApi.updateAddressbook(patientid, book)
      if (res != null) {
        return true
      }
      return false
    }
  }
}
